"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFilterHelper = void 0;
const location_1 = require("src/location");
const taxonomy_1 = require("src/taxonomy");
const CountriesWithStates_1 = require("../Filters/CountriesWithStates");
const FilterTypings_1 = require("../Filters/FilterTypings");
class LocationFilterHelper {
    constructor(props) {
        this.isLoadingCountries = false;
        this.isLoadingStates = false;
        this.onLocationFilterChange = (filteredData, newFilterValue, newSelectedFilters, groupValue) => {
            switch (groupValue) {
                case FilterTypings_1.FilterGroupTypeAlias.Countries:
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [FilterTypings_1.FilterGroupTypeAlias.ZipCode]: [], [FilterTypings_1.FilterGroupTypeAlias.Region]: [], [FilterTypings_1.FilterGroupTypeAlias.City]: [] });
                    this.setState({ showInfoMessage: true });
                    if (newFilterValue) {
                        this.loadStates(newFilterValue);
                    }
                    break;
                case FilterTypings_1.FilterGroupTypeAlias.Region:
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [FilterTypings_1.FilterGroupTypeAlias.ZipCode]: [], [FilterTypings_1.FilterGroupTypeAlias.City]: [] });
                    break;
                case FilterTypings_1.FilterGroupTypeAlias.ZipCode:
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [FilterTypings_1.FilterGroupTypeAlias.Region]: [], [FilterTypings_1.FilterGroupTypeAlias.City]: [] });
                    break;
                case FilterTypings_1.FilterGroupTypeAlias.City:
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [FilterTypings_1.FilterGroupTypeAlias.ZipCode]: [] });
                    break;
                case FilterTypings_1.FilterGroupTypeAlias.Type:
                    if (!this.hasFilterByAlias(filteredData, FilterTypings_1.FilterGroupTypeAlias.City)) {
                        break;
                    }
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [FilterTypings_1.FilterGroupTypeAlias.City]: [] });
                    break;
            }
            return newSelectedFilters;
        };
        this.loadCountries = () => {
            this.isLoadingCountries = true;
            this.countryService.getDataForFilterAutoComplete().then(data => {
                this.countryOptions = data;
                this.setState({ countryOptions: this.countryOptions });
                this.isLoadingCountries = false;
            });
        };
        this.loadStates = (countryCode) => {
            if (!CountriesWithStates_1.mappedCountriesWithStates.some(country => country === countryCode)) {
                return null;
            }
            this.isLoadingStates = true;
            return this.stateService.getDataForFilterAutoComplete(countryCode).then(data => {
                this.stateOptions = { states: data, country: countryCode };
                this.setState({ stateOptions: this.stateOptions });
                this.isLoadingStates = false;
                return data;
            });
        };
        this.getSelectedFilterByType = (selectedFilters, typeAlias) => {
            if (!selectedFilters || !selectedFilters.length) {
                return null;
            }
            for (const filter of selectedFilters) {
                if (filter.indexOf(typeAlias) === 0) {
                    return filter;
                }
            }
            return null;
        };
        this.hasFilterByAlias = (filters, typeAlias) => {
            if (!filters) {
                return false;
            }
            for (const filter of filters) {
                if (filter.typeAlias === typeAlias) {
                    return true;
                }
            }
            return false;
        };
        const { locationApiUrl, culture, locationApiKey } = props;
        if (locationApiUrl) {
            this.countryService = new location_1.CountryService({
                apiUrl: locationApiUrl,
                locationApiKey,
                culture,
                keyMode: location_1.LocationKeyModeEnum.Code,
                prefixNeeded: true,
            });
            this.stateService = new location_1.StatesService({
                apiUrl: locationApiUrl,
                locationApiKey,
                culture,
                keyMode: location_1.LocationKeyModeEnum.Code,
                prefixNeeded: true,
            });
        }
        this.setState = props.setState;
        this.pageId = props.pageId;
        taxonomy_1.countryTaxonomyLoader.countryService = this.countryService;
    }
    onDataLoaded(filteredData, selectedFiltersList) {
        if (this.hasFilterByAlias(filteredData.filters, FilterTypings_1.FilterGroupTypeAlias.Countries) &&
            !this.countryOptions &&
            !this.isLoadingCountries) {
            this.loadCountries();
        }
        const selectedCountryFilter = this.getSelectedFilterByType(selectedFiltersList, FilterTypings_1.FilterGroupTypeAlias.Countries);
        if (selectedCountryFilter &&
            (!this.stateOptions || this.stateOptions.country !== selectedCountryFilter) &&
            !this.isLoadingStates) {
            this.loadStates(selectedCountryFilter);
        }
    }
}
exports.LocationFilterHelper = LocationFilterHelper;
